import useConfig from 'UI/customHooks/useConfig';

interface AvailableLanguage {
  languageCode: string;
  languageName: string;
  isDefault?: boolean;
}

const useAvailableLanguages = (): AvailableLanguage[] => {
  const config = useConfig();
  const languages = config?.cms?.features?.localization?.languages as AvailableLanguage[];
  const availableLanguages =
    languages &&
    Object.keys(languages)
      .map(item => languages[item])
      .filter(item => item.isActive);

  const deprecatedAvailableLanguages =
    (config?.cms?.features?.localization?.availableLanguages as AvailableLanguage[]) ?? [];

  return deprecatedAvailableLanguages || availableLanguages;
};

export default useAvailableLanguages;
